import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTableDataSource } from '@angular/material/table';
import { LoadingBarService } from '@ngx-loading-bar/core';
import moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MasterKeys } from 'projects/lib/medcare-core-lib/src/lib/constants/configuration-modules.constants';
import { MASTERSSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/master-service';
import { MICROSERVICES } from 'projects/lib/medcare-core-lib/src/lib/constants/web-services';
import { ConfirmDynamicDialogComponent } from 'projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component';
import { MultiLanguageService } from 'projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service';
import { PatientDTOObject } from 'projects/lib/medcare-core-lib/src/lib/core/patient-search/patient-search.component';
import { ApplicationConfigService } from 'projects/lib/medcare-core-lib/src/lib/services/application-config.service';
import { AuthService } from 'projects/lib/medcare-core-lib/src/lib/services/auth.service';
import { AppBaseService } from 'projects/lib/medcare-core-lib/src/lib/services/http.service';
import { PatientService } from 'projects/lib/medcare-core-lib/src/lib/services/patient.service';
import { ReportService } from 'projects/lib/medcare-core-lib/src/lib/services/report.service';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { removeSpaces } from '../../../helper/helper.service';
import { baseObj, baseObject } from '../../../interface/IerRegistration';
import { dataObj } from '../../../models/MpatientRegistration';
import { opdEnvironment } from '../../../properties/opd-field-properties';
import { opdNavigation } from '../../../properties/opd-navigation-properties';
import { OPD_REPORT_TYPE, OPD_REPORT_NAME } from '../../../properties/opd-report-properties';
import { OPD_CONST } from '../../../properties/opd-static-properties';
import { OPD_API_URL } from '../../../properties/opd-url-properties';
import { AppointmentService } from '../../../services/Sappointment.service';
import { GeneralUrlService } from '../../../services/SgeneralUrl.service';
import { MasterUrlService } from '../../../services/SmasterUrl.service';
import { CalendarEvent, CalendarView } from 'angular-calendar';

export class SearchControl {
  type: string = "";
  placeholder: string = "";
  value: any = {};
  column: number = 6;
  name: string = "";
  url: string = "";
  selectType: string = "";
  radios: string = "";
  methodName: string = "";
  options: any[] = [];
  masterList: any[] = [];
  searchValue:string="";
  isTodaysDate:string="";
}


@Component({
  selector: 'app-recurring-appointments',
  templateUrl: './recurring-appointments.component.html',
  styleUrl: './recurring-appointments.component.scss',
  providers: [DatePipe]
})

export class RecurringAppointmentsComponent implements OnInit, OnDestroy {
   _onDestroy: Subject<boolean> = new Subject<boolean>();
  primaryIdList: any[] = [];
  slotId: string;
  slotLoadFlag = true;
  patientType = "new";
  selectedDate: Date | null = null;
  values: any = {};
  saveAction: boolean = false;
  now = new Date();
  year = this.now.getFullYear();
  month = this.now.getMonth();
  day = this.now.getDate();
  maxDate = new Date(this.year, this.month, this.day);
  public isPatientNew = true;
  public disableForm = false;
  primaryIdRegex: string = "[A-Za-z0-9]*";
  appointmentForm: FormGroup ;
  public patient: any = {};
  public environment: any = opdEnvironment;
  public mobile = "";
  public patientId = "";
  public isReschedule = false;
  timeSlotList: any = [];
  timeSlotsArray: any = [];
  breakTimes: any = [];
  passD = new Date();
  passYear = this.passD.getFullYear();
  minDateexp = new Date();
  maxDateexp = new Date(this.passYear + 11, 0, 0);
  unitId: any;
  unitCode: any;
  orgId: any;
  appointmentDate: any;
  resultFound: boolean = false;
  displayedColumns: any;
  dataSource = new MatTableDataSource<any>();
  recordsLength: any;
  searchList: any[];
  patientList: any;
  CountryCode: any = null;
  StateCode: any = null;
  CityCode: any = null;
  countryValue: any = null;
  stateValue: any = null;
  cityValue: any = null;
  districtValue: any = null;
  public dropdownValues: any = {};
  slectedSlotId: any[] = [];
  idNumberLength: any = "14";
  error: any = { isError: false, errorMessage: "" };
  bookingDetails: any;
  private subscriptionList = new Subscription();
  apptType: any;
  dilogData: any;
  selectedSlots: any = {};
  dayslots: any[] = [];
  langValue: string = "";
  masterAPI: any = MASTERSSERVICES;
  showExpirDatePicker: boolean = false;
  isHsc: boolean = false;
  patientSearch: FormControl = new FormControl();
  patientFilter: any[] = [];
  countryPrimaryList: any[] = [];
  statePrimaryList: any[] = [];
  cityPrimaryList: any[] = [];
  subdistPrimaryList: any[] = [];
  genderValue: any = null;
  primaryValue: any = null;
  prefixValue: any = null;
  specialReq: any;
  mobileCodeValue: any = null;
  date = new Date();
  mindate = new Date(1920, 0, 1);
  patientAge: {
    years: string;
    months: string;
    days: string;
  } = {
    years: "0",
    months: "0",
    days: "0",
  };
  autoRescheduleData: any;
  FormRequiredFelds: any = {
    emailRequired: false,
    handphoneRequired: false,
    officeRequired: false,
    homeReqired: false,
    patientRequired: false,
    bookingTypeRequired: false,
    refTypeRequired: false,
    refRequired: false,
    companyRequired: false,
    subSepcilityRequired: false,
  };
  Data: Array<any> = [];
  checkArray: any[] = [];
  selectedPatient: any;
  patientTypeCat: any = OPD_CONST.aptref.new;
  reschRemarks: any;
  reason: any;
  reasonList: any[] = [];
  base64textString: any;
  imageUser: any;
  healthPackageList: any[] = [];
  healthPackage: any;
  checkedPackageList: any[] = [];
  primaryIdentifierListModified: boolean = false;
  patientInfoDisplay: string = "";
  searchCriteria: any = null;
  refreshTime: string = "";
  hidePatientSearch = false;
  isPatientEditRights: boolean = false;
  isRegistered: boolean = false;
  patientImage: any;
  mrn: string;
  isDisabled: boolean = false;
  isVip:boolean=false;
  isNoteVisible?:string
  specialReqList:any=[]=[];
  patientData:boolean=false;
  reasons: any[]=[];
  reasonSearch: FormControl = new FormControl();
  mobileNoMax: number=14;
  mobileNoMin: number=8;
  defaultGender: dataObj;
  prefixCodeList: baseObj[] = [];
  gender: string;
  isOverRightBlockedSlot: boolean=false;
  loadingData: boolean=false;
  offset: number=0;
  limit: number=10;
  partientSearch: { 
    MRN: string; 
    PatientName: string; 
    identificationType: string; 
    identificationNumber: string; 
    MobileNo: string; 
    birthDate: string; 
    offset: number; 
    limit: number; 
  };
  datePreferanceDiaplay:string="";
  isSubmitting: boolean = false;
  primaryIdFilteredList: any;
  defaultIdentification: string='';
  primaryIdCode: any;
  unitName: string;
  orgCode: string;
  maxExpiry = new Date(this.year + 20, this.month, this.day);
  maxIdentificationLength:number=25;
  minIdentificationLength:number=0;
  filteredDocsList:baseObject[] = []; 
  doctorSearch :string= '';
  doctorsCount: string = "";

  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  events: CalendarEvent[] = [];

  currentDate: Date = new Date();
  weekDays: Date[] = [];
  monthDays: Date[] = [];
  viewMode: 'week' | 'month' = 'week';
  allSlots: any[];
  public activeDoctor: any = {
    code: "",
    id: "",
    name: "",
    department: "",
    email: "",
  };
  public doctor: any = {};
  department:  any = {};
  appointmentType: any = {};
  slotList: any[]=[];
  isSlots: boolean = false;
  selectedRecurrenceIndex: number = 0; // 0 = No recurrence, 1 = Daily, etc.
  dailyrepeatEvery: number = 1;
  dailyOccurrence: number = 1;
  selectedSlot: any = null;
  showRecurringPanel: boolean = false;
  isShowBookingCalendar: boolean = false;
  weeklyOccurrence: number = 1;
  weeklyrepeatEvery: number = 1;
  weeklyDays: string[] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  selectedDays: string[] = [];
  fullDayMap: { [key: string]: string } = {
    Mon: 'MONDAY',
    Tue: 'TUESDAY',
    Wed: 'WEDNESDAY',
    Thu: 'THURSDAY',
    Fri: 'FRIDAY',
    Sat: 'SATURDAY',
    Sun: 'SUNDAY',
  };
  monthlyOccurrence: number = 1;
  monthlyRepeatEvery: number = 1;
  monthlyOption: string = 'dayOfMonth';

  dayOfMonth: number;
  weekdayName: string;
  nthWeek: string;
  recurringBookings: any[]= [];
  isShowRecurringSlots: boolean = false;
  selectedSlotIndex: any;
  targetEpoch: number;
  unAvailableSlot: number = 0;

  constructor(
    public dialogRef: MatDialogRef<RecurringAppointmentsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: RecurringAppointmentsComponent,
    public baseservice: AppBaseService,
    public snackBar: MatSnackBar,
    public loadingBar: LoadingBarService,
    private authService: AuthService,
    public datepipe: DatePipe,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private patientService: PatientService,
    private applicationConfigService: ApplicationConfigService,
    private langService: MultiLanguageService,
    public generalApiServiceapt: GeneralUrlService,
    public masterApiServiceapt: MasterUrlService,
    private appoinmentServiceApt: AppointmentService,
    private reportService: ReportService, 
    private appBaseService: AppBaseService,
    public masterApiService: MasterUrlService,
    private ngxService: NgxUiLoaderService,
    private cdr: ChangeDetectorRef
  ) {
    this.getUnitData();
    this.dilogData = data;

    this.dilogData.daySlot.forEach((element) => {
      if (element.id == data.slotId) {
        this.slectedSlotId.push(element.id);
        element[OPD_CONST.aptref.selected] = true;
      } else {
        var currentTime = new Date().getTime() / 1000;
        if (currentTime < element.startDateTimeEpoch) {
          var minutesToAdd = this.dilogData.blocktime;
          var currentDate = new Date();
          var cuurentTimeappconfig =
            Number(new Date(currentDate.getTime() + minutesToAdd * 60000)) /
            1000;

          if (cuurentTimeappconfig > element.startDateTimeEpoch) {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = true;
          } else {
            element[OPD_CONST.aptref.selected] = false;
            element[OPD_CONST.aptref.past] = false;
            // element[OPD_CONST.aptref.blocked] = false;
          }
        } else {
          element[OPD_CONST.aptref.selected] = false;
          element[OPD_CONST.aptref.past] = true;
        }
        element[OPD_CONST.aptref.blocked] = element.businessStatus === OPD_CONST.aptSlotStatus.HOLD;
        element[OPD_CONST.aptref.booked] = element.businessStatus === OPD_CONST.aptSlotStatus.busy;
        element[OPD_CONST.aptref.available] = element.businessStatus === OPD_CONST.aptSlotStatus.free;
        if(element.tempStatus){
          element[OPD_CONST.aptref.blocked] = element.tempStatus ===OPD_CONST.aptSlotStatus.blocked;
        }
      }
     
    });

    this.selectedSlots = {
      start: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.StartTime
        : null,
      end: this.dilogData.calenderEvent
        ? this.dilogData.calenderEvent.EndTime
        : null,
    };
    if (this.dilogData.isQuickSearch) {
      this.selectedSlots = {
        start: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.start
          : this.dilogData.selectedTime.start,
        end: this.dilogData.selectedTime
          ? this.dilogData.selectedTime.end
          : this.dilogData.selectedTime.end,
      };
      this.slectedSlotId.push(this.dilogData.slotId);
    }
  }
  /**
   *Load metthod of dialog window
   *
   * @memberof RecurringAppointmentsComponent
   */
  ngOnInit() {
    this.generateView();
    this.department = this.dilogData.department;
    this.appointmentType = this.dilogData.appointmentType;
    this.dilogData.doctorList.map((data)=>{
      data.available= data.doctoreAvailable == OPD_CONST.noSlotsAvailable
                      ? this.langService.get("AppointmentListPage.noSlotsAvailable")
                      : this.langService.get("AppointmentListPage.nextAvailability") + data.doctoreAvailable,
      data.doctoreAvailableDate= data.doctoreAvailable
    })
    this.filteredDocsList = this.dilogData.doctorList;
    this.doctorsCount =
    this.dilogData.doctorList.length > 0 ? this.dilogData.doctorList.length : "";
    this.getPrimaryIdList();  
     this.appointmentForm = this.formBuilder.group({
      IdNumber: [null, [removeSpaces]],
      IdType: ["", Validators.required],
      Title: ["", Validators.required],
      FullName: [null, [Validators.required]],
      Gender: [""],
      DOB: ["", Validators.required],
      realdob: [true],
      idExpiry: [""],
      Age: [""],
      // Email: [
      //   "",
      //   [
      //     Validators.pattern(
      //       "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+[.]+[a-zA-Z0-9-.]+$"
      //     ),
      //   ],
      Email: [
        "",
        [this.emailOrMaskedValidator()]
      
      ],
      countryCodemobile: ["", [Validators.required]],
      HandPhoneNumber: [null, [Validators.required, removeSpaces]],
      OffciePhoneNumber: [""],
      HomePhoneNumber: [""],
      countryPrimary: [""],
      statePrimary: [""],
      cityPrimary: [""],
      subDistrictPrimary: [""],
      pincodePrimary: ["", [Validators.pattern(/^-?(0|[1-9]\d*)?$/)]],
      addressPrimary: [""],
      CompanyType: [""],
      SubSpecility: [""],
      Remarks: [""],
    });
    this.searchList = this.appoinmentServiceApt.appoinmentSearchList(this);
    this.authService.getUnit().then((value: any) => {
      this.unitId = value.unitId;
      this.orgId = value.orgId;
      this.unitCode = value.unitCode;
    });
    this.langService.getCurrentLanguage().then((val) => {
      this.langValue = val;
      if (this.langValue == "en") this.Data = OPD_CONST.specialReqirements;
      else this.Data = OPD_CONST.specialReqirementsMY;
    });
    this.getCountryList();
    this.getspecialReqList();
    this.getHealthPackgeList();
    this.searchOnChanges();
    this.isHsc =
      this.dilogData.appointmentType == OPD_CONST.aptref.apttTypeHscCode
        ? true
        : false;
    if (this.dilogData.reScheduleData) {
      this.autoRescheduleData = this.dilogData.reScheduleData;
      this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
        ? this.setTempPatient(this.autoRescheduleData)
        : this.setSearch(this.autoRescheduleData);
      let patientType =
        this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? OPD_CONST.aptref.new
          : OPD_CONST.appoinmentRef.registred;
      this.patientType = patientType;
      this.patientTypeCat = patientType;
      this.isPatientNew = patientType == OPD_CONST.aptref.new;
    }
    if(this.dilogData.waitingPatient?.id){
      setTimeout(() => {
        this.getWaitingpatient();
      }, 1500);
    }
    this.reasonTypeMaster();
    this.onChanges();
    this.authService.getUserInfo().then((value: any) => {
      if (value.userSpecialRightList && value.userSpecialRightList.length > 0) {
        value.userSpecialRightList.forEach((element) => {
          if (element.specialRightCode == OPD_CONST.splRightOverRighteBlockedSlot)
            this.isOverRightBlockedSlot = true;
        });
      }
    });
  }
  getUnitData() {
    this.authService.getUnit().then((value: any) => {
      this.unitCode = value.unitCode;
      this.unitName = value.unitDescription;
      this.orgCode=value.orgCode;
      this.getOrgAppConfigList();
    });
  }

  getNthWeek(date: Date): string {
    const day = date.getDate();
    if (day <= 7) return 'first';
    else if (day <= 14) return 'second';
    else if (day <= 21) return 'third';
    else if (day <= 28) return 'fourth';
    return 'last';
  }

  onTabChange(e){
    console.log(e);
    if(e.index == 2){
      this.setSelectedWeekdayFromDate(this.selectedDate);
    }
    else if(e.index == 3){
      this.dayOfMonth = this.selectedDate.getDate(); // e.g., 8th
      this.weekdayName = this.selectedDate.toLocaleString('default', { weekday: 'long' }); // e.g., Thursday
      this.nthWeek = this.getNthWeek(this.selectedDate); // e.g., second
    }
  }

  filterDoctorList(): void {
    const search = this.doctorSearch.toLowerCase();

    if (!search) {
      this.filteredDocsList = this.dilogData.doctorList;
      return;
    }

    this.filteredDocsList = this.dilogData.doctorList.filter((doctor) =>
      doctor.desc.toLowerCase().includes(search)
    );
  }

  increaseRepeatEvery() {
    this.dailyrepeatEvery++;
  }
  
  decreaseRepeatEvery() {
    if (this.dailyrepeatEvery > 1) {
      this.dailyrepeatEvery--;
    }
  }

  decreaseOccurrences(){
    if (this.dailyOccurrence > 1) {
      this.dailyOccurrence--;
    }
  }

  increaseOccurrences(){
    this.dailyOccurrence++;
  }

  increaseWeeklyRepeatEvery() {
    this.weeklyrepeatEvery++;
  }
  
  decreaseWeeklyRepeatEvery() {
    if (this.weeklyrepeatEvery > 1) {
      this.weeklyrepeatEvery--;
    }
  }

  decreaseWeeklyOccurrences(){
    if (this.weeklyOccurrence > 1) {
      this.weeklyOccurrence--;
    }
  }

  increaseWeeklyOccurrences(){
    this.weeklyOccurrence++;
  }

  toggleDay(day: string) {
  const fullDay = this.fullDayMap[day];
  const index = this.selectedDays.indexOf(fullDay);

  if (index >= 0) {
    this.selectedDays.splice(index, 1);
  } else {
    this.selectedDays.push(fullDay);
  }
  }
  
  setSelectedWeekdayFromDate(date: Date): void {
    const dayIndex = date.getDay(); // 0 = Sunday
    const abbr = dayIndex === 0 ? 'Sun' : this.weeklyDays[dayIndex - 1];
    this.selectedDays = [this.fullDayMap[abbr]];
  }

  increasemonthlyRepeatEvery() {
    this.monthlyRepeatEvery++;
  }
  
  decreasemonthlyRepeatEvery() {
    if (this.monthlyRepeatEvery > 1) {
      this.monthlyRepeatEvery--;
    }
  }

  decreasemonthlyOccurrences(){
    if (this.monthlyOccurrence > 1) {
      this.monthlyOccurrence--;
    }
  }

  increasemonthlyOccurrences(){
    this.monthlyOccurrence++;
  }

  bookCalendar(){
    //check all madatory form fields having values and patient is selected if we selected existing
    // add validation of doctor selection also
     for (var i in this.appointmentForm.controls) {
      this.appointmentForm.controls[i].markAsTouched();
    }
    if (this.appointmentForm.valid && this.doctor) {
      this.isShowBookingCalendar = true;
    }
    else{
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("AppointmentPage.PleaseSelectDoctorAndFormfields"),
        {
          duration: 3000,
        }
      );
      return;
    }
  }

  setViewMode(mode: 'week' | 'month') {
    this.viewMode = mode;
    this.generateView();
  }
  
  prev() {
    if (this.viewMode === 'week') {
      this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() - 7));
    } else {
      this.currentDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth() - 1));
    }
    this.generateView();
  }
  
  next() {
    if (this.viewMode === 'week') {
      this.currentDate = new Date(this.currentDate.setDate(this.currentDate.getDate() + 7));
    } else {
      this.currentDate = new Date(this.currentDate.setMonth(this.currentDate.getMonth() + 1));
    }
    this.generateView();
  }
  
  generateView() {
    this.weekDays = this.getWeekDays(this.currentDate);
    this.monthDays = this.getMonthDays(this.currentDate);
  }
  
  getWeekDays(date: Date): Date[] {
    const start = new Date(date);
    const day = start.getDay();
    const diff = start.getDate() - day + (day === 0 ? -6 : 1); // start on Monday
    start.setDate(diff);
    return Array.from({ length: 7 }, (_, i) => new Date(start.getFullYear(), start.getMonth(), start.getDate() + i));
  }
  
  getMonthDays(date: Date): Date[] {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1);
    const lastDay = new Date(year, month + 1, 0);
    const days = [];
  
    // Align to week starting Monday
    const startDay = firstDay.getDay() === 0 ? 6 : firstDay.getDay() - 1;
    for (let i = 0; i < startDay; i++) {
      days.push(new Date(year, month, i - startDay + 1));
    }
  
    for (let d = 1; d <= lastDay.getDate(); d++) {
      days.push(new Date(year, month, d));
    }
  
    const total = days.length;
    const remaining = total % 7 === 0 ? 0 : 7 - (total % 7);
    for (let i = 1; i <= remaining; i++) {
      days.push(new Date(year, month + 1, i));
    }
  
    return days;
  }

  onDateClick(date: Date, booking?) {
    if(date && this.viewMode == 'month'){
      this.viewMode = 'week';
    }
    this.slotList= [];
    console.log(date);
    // Trigger your API call here
    // if (this.isDateDisabled(date)) return;

  const selectedDate = new Date(date);

  let startDate: number;
  let endDate: number;

    const startOfDay = new Date(selectedDate);
    startOfDay.setHours(0, 1 , 0, 0);
    startDate = Math.floor(startOfDay.getTime() / 1000);

  const endOfDay = new Date(selectedDate);
  endOfDay.setHours(23, 59, 59, 999);
  endDate = Math.floor(endOfDay.getTime() / 1000);

  const aptmentTypeValue = this.dilogData.appointmentTypeList.find(
    (i) => i.code == this.dilogData.appointmentType
  ); 

  let url: string;
  if (
    aptmentTypeValue.code === OPD_CONST.aptref.apttypeDeptCode ||
    aptmentTypeValue.code === OPD_CONST.aptref.apttTypeHscCode
  ) {
    url = this.appoinmentServiceApt.setURlslotData(this, startDate, endDate);
  } else {
    url = this.appoinmentServiceApt.setURLmultipleDoctor(this, startDate, endDate);
  }

  if (aptmentTypeValue.id) {
    this.subscriptionList.add(
      this.generalApiServiceapt
        .getTypeApi(OPD_API_URL.OPD_SERVICE, url)
        .subscribe((res: any[]) => {
          this.allSlots = res;
          this.events = [];
          if (res && res[0]) {
            const now = new Date();
            const currentEpoch = Math.floor(now.getTime() / 1000);
            const selectedIsToday = this.isSameDay(selectedDate, now);
          
            res[0].Slots.forEach((element: any) => {
              const isFree = element.businessStatus === "free";
          
              // If selected date is today, filter by current time
              const isValidSlot = selectedIsToday
                ? element.startDateTimeEpoch >= currentEpoch
                : true;
          
              if (isFree && isValidSlot) {
                this.slotList.push(element);
              }
            });
          
            this.isSlots = true;
          } else {
            this.slotList = [];
            this.isSlots = false;
          }
          console.log(this.slotList);
          if(this.recurringBookings?.length > 0 && booking){
            this.targetEpoch = Number(booking.slotStartDateTime);
          }
        })
    );
  }

  // Save selection if needed
  this.selectedDate = selectedDate;
  }

isSameDate = (d1: Date, d2: Date): boolean => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
};

  onSlotClick(slot: any) {
    this.selectedSlot = slot;
    if(this.recurringBookings?.length > 0){
      this.isShowRecurringSlots = true;
      const index = this.recurringBookings.findIndex((rb) =>{
        let bookingDate = rb.date ? new Date(rb.date) : new Date(rb.slotStartDateTime);
        return this.isSameDate(bookingDate, this.selectedDate);
      });

      if (index !== -1) {
        this.recurringBookings[index].slotStartDateTime = this.selectedSlot.startDateTimeEpoch.toString();
        this.recurringBookings[index].slotEndDateTime = this.selectedSlot.endDateTimeEpoch.toString();
        if(this.recurringBookings[index].slotStatus == "UnAvailable"){
          this.recurringBookings[index].slotStatus = "Available";
          this.recurringBookings[index].date = this.datepipe.transform(this.selectedSlot.start, 'yyyy-MM-dd')
        }
      }
    }
    else{
      this.showRecurringPanel = true;
    }
  }

  goBack() {
    this.selectedSlot = null;
    this.showRecurringPanel = false;
  }

  isSameDay(date1: Date, date2: Date): boolean {
    return (
      date1.getFullYear() === date2.getFullYear() &&
      date1.getMonth() === date2.getMonth() &&
      date1.getDate() === date2.getDate()
    );
  }

  public doctorOnChange(doctor) {
      this.activeDoctor.id = doctor.id;
      this.activeDoctor.code = doctor.code;
      this.activeDoctor.name = doctor.desc;
      this.activeDoctor.email = doctor.email ? doctor.email : "";
      this.doctor = doctor;
      const availableDate = this.parseAvailableDate(doctor.doctoreAvailableDate);

      if (availableDate) {
        this.onDateClick(availableDate);
      }
  } 

  parseAvailableDate(dateStr: string): Date | null {
    const match = dateStr.match(/(\w+),(\w+ \d+)/);
    if (!match) {
      return null;
    }
    const currentYear = new Date().getFullYear();
    const formattedDateStr = `${match[2]} ${currentYear}`;
    const parsedDate = new Date(formattedDateStr);
  
    return isNaN(parsedDate.getTime()) ? null : parsedDate;
  }

  isToday(date: Date): boolean {
    const today = new Date();
    return date.getDate() === today.getDate() &&
           date.getMonth() === today.getMonth() &&
           date.getFullYear() === today.getFullYear();
  }
  
  isSelected(date: Date): boolean {
    return this.selectedDate &&
           date.toDateString() === this.selectedDate.toDateString();
  }
  
  isDateDisabled(date: Date): boolean {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
  
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
  
    return d < today  // code to disable sunday  : || d.getDay() === 0;
  }

  isPrevDisabled(): boolean {
    const today = new Date();
  
    if (this.viewMode === 'week') {
      const weekStart = this.getWeekDays(this.currentDate)[0];
      return this.isSameWeek(today, weekStart);
    }
  
    if (this.viewMode === 'month') {
      return today.getMonth() === this.currentDate.getMonth() &&
             today.getFullYear() === this.currentDate.getFullYear();
    }
  
    return false;
  }
  
  isSameWeek(d1: Date, d2: Date): boolean {
    const getMonday = (date: Date) => {
      const day = date.getDay() || 7;
      const monday = new Date(date);
      monday.setDate(date.getDate() - day + 1);
      monday.setHours(0, 0, 0, 0);
      return monday;
    };
    return getMonday(d1).getTime() === getMonday(d2).getTime();
  }
  //

  getEndOfWeek(date: Date): Date {
    const day = date.getDay(); // 0 (Sun) - 6 (Sat)
    const diff = 6 - day; // days until Saturday
    const endDate = new Date(date);
    endDate.setDate(date.getDate() + diff);
    return endDate;
  }
  
  handleDayClick({ date }: { date: Date }): void {
    this.selectedDate = date;
    console.log('Clicked date:', date);
    // Call API here
  }

  handleDayHeaderClick(day: any): void {
    console.log('Header clicked:', day.date);
    // Call your API here
  }

  setView(view: CalendarView) {
    this.view = view;
  }

  goToToday(): void {
    this.viewDate = new Date();
  }

  increment(): void {
    const days = this.view === CalendarView.Week ? 7 : 30;
    this.viewDate = new Date(this.viewDate.setDate(this.viewDate.getDate() + days));
  }

  decrement(): void {
    const days = this.view === CalendarView.Week ? 7 : 30;
    this.viewDate = new Date(this.viewDate.setDate(this.viewDate.getDate() - days));
  }

    getOrgAppConfigList() {
      let appConfig: any;
       this.appBaseService.setResourceURL(MICROSERVICES.OPD_SERVICE);
          this.appBaseService
            .getResource("appConfiguration/findConfigByModule?unitCode=null&orgCode="+this.orgCode+"&moduleName="+OPD_CONST.patientManagement+"&keyName=")
            .pipe(takeUntil(this._onDestroy))
        .subscribe((res) => {
          if (res) {
            appConfig = res.keys;
            appConfig.forEach((element) => {
             
              if (element.key == MasterKeys.primaryIdentification){
                if (element.valueList?.length > 0 && element.valueList[0]?.code) {
                  let value = this.primaryIdFilteredList.find(i=>i.code == element.valueList[0]?.code)
                    this.primaryValue = value ? value.code : "";
                    this.appointmentForm.controls["IdType"].setValue(this.primaryValue);
                    this.cdr.detectChanges();
                    this.primaryIdentificationOnChange(value);
              }
            }
          });
          } 
        });
    }   

  getPrimaryIdList() {
    this.masterApiService
      .getTypeMaster(OPD_API_URL.M_IDENTIFICATION)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((data: any) => {
        this.primaryIdFilteredList = data.filter((i) => i.isPrimaryId);
      });
  }
  
  onChanges() {
    this.subscriptionList.add(
      this.reasonSearch.valueChanges.subscribe((value) => {
        this.reasonList = this.reasons.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }

  /**
   * To initiate quick search
   * @param event
   */
  searchByMRN(event) {
    let result = { MRN: event.target.value };
    this.setSearch(result);
  }
  /**
   *on click checkbox change event
   *
   * @param {*} e
   * @param {*} data
   * @param {*} isReschedue
   * @memberof RecurringAppointmentsComponent
   */
  onCheckboxChange(e: any, data, isReschedue) {
    if (isReschedue) {
      this.checkArray.push(data);
    } else {
      if (e.target.checked) {
        this.checkArray.push(data);
      } else {
        const index: number = this.checkArray.indexOf(data);
        if (index !== -1) {
          this.checkArray.splice(index, 1);
        }
      }
    }
  }
  /**
   *search change event
   *
   * @memberof RecurringAppointmentsComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.appointmentForm.controls["DOB"].valueChanges.subscribe(
        (val) => {
          this.patientAge = this.patientService.calculateAge(val,"formatted");
        }
      )
    );
  }
  /**
   *add minutes
   *
   * @param {*} date
   * @param {*} minutes
   * @return {*}
   * @memberof RecurringAppointmentsComponent
   */
  addMinutes(date, minutes) {
    return new Date(date.getTime() + minutes * 60000);
  }
  /**
   *select slot event
   *
   * @param {*} slot
   * @memberof RecurringAppointmentsComponent
   */
  slectedSlot(slot) {
    if(this.isOverRightBlockedSlot  && !slot.booked && !slot.past){
      if (slot.selected) {
        slot.selected = false;
      } else {
        this.dilogData.daySlot.forEach((element) => {
          if (element.selected === true) {
            element.selected = false;
          }
        });
        var intialselectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.selected === true
        );
        var selectedIndex = this.dilogData.daySlot.findIndex(
          (i) => i.id === slot.id
        );

        if (intialselectedIndex <= 0) {
          slot.selected = true;
        }
        if (
          selectedIndex === intialselectedIndex - 1 ||
          selectedIndex === intialselectedIndex + 1
        ) {
          slot.selected = true;
        }
        var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
        var next = this.dilogData.daySlot[selectedIndex + 1].selected;
        if (prev || next) {
          slot.selected = true;
        }
      }
      this.slotSelectedasGroup();
    
    }else{
    if (slot.past) {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsUnavailable"),
        {
          duration: 3000,
        }
      );
    }else if(slot.booked){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.slotIsAlreadybooked"),
        {
          duration: 3000,
        });
    } else {
      if (slot.blocked) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.slotIsBlocked"),
          {
            duration: 3000,
          }
        );
      } else {
        if (slot.selected) {
          slot.selected = false;
        } else {
          this.dilogData.daySlot.forEach((element) => {
            if (element.selected === true) {
              element.selected = false;
            }
          });
          var intialselectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.selected === true
          );
          var selectedIndex = this.dilogData.daySlot.findIndex(
            (i) => i.id === slot.id
          );

          if (intialselectedIndex <= 0) {
            slot.selected = true;
          }
          if (
            selectedIndex === intialselectedIndex - 1 ||
            selectedIndex === intialselectedIndex + 1
          ) {
            slot.selected = true;
          }
          var prev = this.dilogData.daySlot[selectedIndex - 1].selected;
          var next = this.dilogData.daySlot[selectedIndex + 1].selected;
          if (prev || next) {
            slot.selected = true;
          }
        }
        this.slotSelectedasGroup();
      }
    }
    }
  }
  /**
   *selected as group
   *
   * @memberof RecurringAppointmentsComponent
   */
  slotSelectedasGroup() {
    this.slectedSlotId = [];
    var slected: any = [];
    this.dilogData.daySlot.forEach((element) => {
      if (element.selected) {
        slected.push(element);
        this.slectedSlotId.push(element.id);
      }
    });

    this.selectedSlots = {
      start: slected[0].start,
      end: slected[slected.length - 1].end,
    };
  }

  /**
   *get data Reason master
   *
   * @memberof RecurringAppointmentsComponent
   */
  reasonTypeMaster() {
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : false
     if (isReschedule==true){
      this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
      this.appBaseService
        .getResource(OPD_API_URL.M_REASON_MASTER_QUERY_NEW+"APRS",true)
        .subscribe((res) => {
          res.forEach((element) => {
            this.reasonList.push(element);
            this.reasons.push(element);
          });
        });
     }
    else {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_REASON_MASTER_QUERY)
        .subscribe((data: any) => {
          this.reasonList = data;
          this.reasons =data;
        })
      );
  }
}
  /**
   *It is the source of country data.
   *
   * @memberof PatientRegistrationComponent
   */
  getCountryList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_COUNTRY,true)
        .subscribe((data: any) => {
          this.countryPrimaryList = data;
        })
    );
  }
  getPrifixList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PREFIX)
        .subscribe((data: any) => {
          this.prefixCodeList = data;
        })
    );
  }

  getspecialReqList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_SPECIALREQLIST,true)
        .subscribe((data: any) => {
          this.specialReqList = data;
        })
    );
  }

  /**
   *get health package
   *
   * @memberof RecurringAppointmentsComponent
   */
  getHealthPackgeList() {
    this.subscriptionList.add(
      this.masterApiServiceapt
        .getTypeMaster(OPD_API_URL.M_PACKAGE,true)
        .subscribe((data: any) => {
          this.healthPackageList = data;
        })
    );
  }
  /**
   *Passing countryCode to get the stateList
   *
   * @param {*} countryCode
   * @memberof PatientRegistrationComponent
   */
  getStatePrimaryList(countryCode, isCode) {
    if (countryCode) {
      let result: any = "";
      if (isCode)
        result = this.countryPrimaryList.find((i) => i.code == countryCode);
      else
        result = this.countryPrimaryList.find(
          (i) => i.code == countryCode.code
        );
      this.CountryCode = {
        field: OPD_API_URL.M_COUNTRYM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_STATE + OPD_API_URL.M_COUNTRY_VALUE + result.id
          )
          .subscribe((res) => {
            this.statePrimaryList = res;
            if (this.selectedPatient) {
              const stateres = this.statePrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.stateList[0].code
                        : this.selectedPatient.extendedAddress.state.code
                      : this.selectedPatient.extendedAddress.state.code
                    : "")
              );
              this.stateValue = stateres ? stateres.code : "";
              this.getCityPrimaryList(stateres);
            }
          })
      );
    }
  }

  /**
   *Passing stateCode to get the cityList
   *
   * @param {*} stateCode
   * @memberof PatientRegistrationComponent
   */
  getCityPrimaryList(stateCode) {
    if (stateCode) {
      const result = this.statePrimaryList.find(
        (i) => i.code == stateCode.code
      );
      this.StateCode = {
        field: OPD_API_URL.M_STATEM,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_CITY + OPD_API_URL.M_STATE_VALUE + result.id
          )
          .subscribe((res) => {
            this.cityPrimaryList = res;
            if (this.selectedPatient) {
              const cityres = this.cityPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.cityList[0].code
                        : this.selectedPatient.extendedAddress.city.code
                      : this.selectedPatient.extendedAddress.city.code
                    : "")
              );
              this.cityValue = cityres ? cityres.code : "";
              this.getSubDistrictPrimaryList(cityres);
            }
          })
      );
    }
  }

  /**
   *Passing cityCode to get the subDistrictList
   *
   * @param {*} cityCode
   * @memberof PatientRegistrationComponent
   */
  getSubDistrictPrimaryList(cityCode) {
    if (cityCode) {
      const result = this.cityPrimaryList.find((i) => i.code == cityCode.code);
      this.CityCode = {
        field: OPD_API_URL.M_CITY_VALUE,
        value: result.id,
      };
      this.subscriptionList.add(
        this.masterApiServiceapt
          .getTypeMaster(
            OPD_API_URL.M_AREA + OPD_API_URL.M_AREA_VALUE + result.id
          )
          .subscribe((res) => {
            this.subdistPrimaryList = res;

            if (this.selectedPatient) {
              const distres = this.subdistPrimaryList.find(
                (i) =>
                  i.code ==
                  (this.selectedPatient.extendedAddress
                    ? this.dilogData.reScheduleData
                      ? this.dilogData.reScheduleData.type == "TEMP"
                        ? this.selectedPatient.extendedAddress.areaList[0].code
                        : this.selectedPatient.extendedAddress.area.code
                      :this.selectedPatient.extendedAddress.area? this.selectedPatient.extendedAddress.area.code:""
                    : "")
              );
              this.districtValue = distres ? distres.code : "";
            }
          })
      );
    }
  }

  /**
   *identifiation change event
   *
   * @param {*} idTypeCode
   * @memberof RecurringAppointmentsComponent
   */
  // primaryIdentificationOnChange(idTypeCode: any) {
  //   if (idTypeCode.code == OPD_CONST.idTypePassportValue)
  //     this.showExpirDatePicker = true;
  //   else this.showExpirDatePicker = false;
  // }
  primaryIdentificationOnChange(idTypeCode: any) {
    let appointmentForm = this.appointmentForm.controls;
    appointmentForm["IdNumber"].setValue('');
    if (idTypeCode.value) {
      this.primaryIdCode = this.primaryIdFilteredList.find(
        (s) => s.code == idTypeCode.value
      );
    }else{
        this.primaryIdCode = this.primaryIdFilteredList.find(
          (s) => s.code == idTypeCode.code
        );
      }
    // if (idTypeCode) {
      if (this.primaryIdCode) {
        if (this.primaryIdCode.isMyKad == true) {
          this.primaryIdRegex = "^[0-9 -]+$";
        } else {
          this.primaryIdRegex = this.primaryIdCode.validation
            ? this.primaryIdCode.validation
            : "";
        }
      }
      if (this.primaryIdCode.expiryDuration) {
        appointmentForm["idExpiry"].enable();
      
              const currentDate = new Date().getFullYear();
              const maxExpiryDurationDate = new Date();
              maxExpiryDurationDate.setFullYear(currentDate + this.primaryIdCode.expiryDuration);
      
              this.maxExpiry = maxExpiryDurationDate;
            }
            else{
              this.maxExpiry= new Date(this.year + 20, this.month, this.day);
            }
           if (this.primaryIdCode.validation) {
              this.primaryIdRegex = this.primaryIdCode.validation;
              // this.primaryIdRegex = "^[a-zA-Z0-9]{0,9}$";
             const match = this.primaryIdRegex.match(/\{(\d+),(\d+)\}/);
             this.minIdentificationLength = match ? parseInt(match[1], 10) : null;
             this.maxIdentificationLength = match ? parseInt(match[2], 10) : null;
           
             this.appointmentForm.controls["IdNumber"].setValidators([
               Validators.pattern(this.primaryIdRegex)
             ]);
           }else{
            this.maxIdentificationLength=25;
            this.minIdentificationLength=0;
            this.primaryIdRegex=OPD_CONST.primaryIdRegix;
            this.appointmentForm.controls["IdNumber"].setValidators([
              Validators.pattern(this.primaryIdRegex)
            ]);
           }
           this.appointmentForm.controls["IdNumber"].updateValueAndValidity();
      if (!this.selectedPatient) {
        if (this.primaryIdCode.code == OPD_CONST.idTypePassportValue) {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].enable();
          this.showExpirDatePicker = true;

          // appointmentForm.issuedCountryPrimary.setValue("");
          // appointmentForm.issuedCountryPrimary.enable();
        } else {
          appointmentForm["idExpiry"].setValue("");
          appointmentForm["idExpiry"].disable();

          // appointmentForm.issuedCountryPrimary.setValue("");
          // appointmentForm.issuedCountryPrimary.disable();
          this.showExpirDatePicker = false;
        }
        this.primaryNumberOnKeyUp(appointmentForm["IdNumber"].value);
      }
    // }
  }
  /**
   *calling method after focus out
   *
   * @param {string} value
   * @memberof RecurringAppointmentsComponent
   */
  idFocusOut(value: string) {
    this.validationOnPrimarynumber(value);
    if (this.patientId) {
      if (this.selectedPatient.id) this.primaryIdentifierListModified = true;
    }

    let primaryIdCode = this.appointmentForm.get("primaryId").value;
    if (primaryIdCode) {
      if (primaryIdCode.isMyKad && value.length < 14)
        this.appointmentForm.controls["primaryNumber"].setErrors({
          incorrect: true,
        });
    }
  }
  /**
   *adding validation on primary number
   *
   * @param {string} value
   * @memberof RecurringAppointmentsComponent
   */
  primaryNumberOnKeyUp(value: string) {
    try {
      let primaryIdCode = this.appointmentForm.value.IdType;
      value = value.replace(/\s/g, '');
      this.appointmentForm.controls["IdNumber"].setValue(value);
      if (primaryIdCode) {
        if (primaryIdCode == OPD_CONST.idTypemykadValue) {
        }
        let primaryIdentify = this.primaryIdList.find(
          (i) => i.code == primaryIdCode.code
        );

        if (primaryIdCode) {
          if (primaryIdCode.isMyKad) {
            var r = /(\D+)/g,
              npa = "",
              nxx = "",
              last4 = "";
            value = value.replace(r, "");
            var c: string = value;
            npa = value.substr(0, 6);
            nxx = value.substr(6, 2);
            last4 = value.substr(8, 4);
            value = npa + "-" + nxx + "-" + last4;
            this.appointmentForm.controls["IdNumber"].setValue(value ? value : "");
            this.primaryIdRegex = "^[0-9 -]+$";
          }
          if (value.length >= 12 && primaryIdCode.isMyKad) {
            // if (
            //   value.length == 14 &&
            //   primaryIdCode == OPD_CONST.appoinmentRef.myKad
            // )
            const array = Array.from(c);
            if (array[0] + array[1] >= "30" && array[0] + array[1] <= "99") {
              const Calculated_year = array[0] + array[1];
              const cal_month = array[2] + array[3];
              const cal_day = array[4] + array[5];

              const yr = +Calculated_year;
              const mn = +cal_month;
              const dat = +cal_day;
              this.appointmentForm.controls["DOB"].setValue(
                new Date(yr, mn - 1, dat)
              );
              this.appointmentForm.controls["realdob"].setValue(true);
            } else if (
              array[0] + array[1] >= "00" &&
              array[0] + array[1] <= "29"
            ) {
              const Calculated_year = "2" + "0" + array[0] + array[1];
              const cal_month = array[2] + array[3];
              const cal_day = array[4] + array[5];

              const yr = +Calculated_year;
              const mn = +cal_month;
              const dat = +cal_day;
              var d = new Date();
              var n = d.getFullYear();
              if (parseInt(Calculated_year) > n) {
                this.snackBar.open(
                  this.langService.get("CommonAppoinment.FutureAgeMessage"),
                  this.langService.get("CommonAppoinment.warning"),
                  {
                    duration: 10000,
                  }
                );
                this.appointmentForm.controls["DOB"].setValue("");
              } else {
                this.appointmentForm.controls["DOB"].setValue(
                  new Date(yr, mn - 1, dat)
                );
              }
            }
          }
        }
      }
    } catch (ex) {}
  }
  /**
   *validation primary number
   *
   * @param {string} value
   * @memberof PatientRegistrationComponent
   */
   validationOnPrimarynumber(value: string) {
    if (this.patientId == "" && value.length > 0) {
      let primaryIdCode = this.appointmentForm.controls["IdType"].value;
      if (primaryIdCode) {
        this.generalApiServiceapt
          .getTypeApi(
            OPD_API_URL.OPD_SERVICE,
            OPD_API_URL.OPD_DUPLICATE + primaryIdCode.code + "&value=" + value.replace(/-/g, '')
          )
          .pipe(takeUntil(this._onDestroy))
          .subscribe((res) => {
            if(res!=null){
             this.appointmentForm.controls["IdNumber"].setValue("");
            }
           });
      }
    }
  }
  /**
   *
   *
   * @param {*} companyValue
   * @memberof RecurringAppointmentsComponent
   */
  pakageChecked(packageValue) {
    this.checkedPackageList = [];
    for (let i = 0; i < this.healthPackageList.length; i++) {
      if (packageValue.indexOf(this.healthPackageList[i]) != -1)
        this.checkedPackageList.push(this.healthPackageList[i]);
    }
  }
  /**
   *binding gender value
   *
   * @param {*} prefixvalue
   * @memberof RecurringAppointmentsComponent
   */
  // getGender(prefixvalue) {
  //   let formappoinment = this.appointmentForm.controls;
  //   let res =
  //     prefixvalue && prefixvalue.genderMaster
  //       ? prefixvalue.genderMaster.code
  //       : "";
  //   if (res) {
  //     this.genderValue = res;
  //     formappoinment.Gender.disable();
  //   } else {
  //     this.genderValue = "";
  //     formappoinment.Gender.enable();
  //   }
  // }

  getGender(prefixvalue) {
    let formRegistration = this.appointmentForm.controls;
    let res =
      prefixvalue && prefixvalue.genderMaster
        ? prefixvalue.genderMaster.code
        : "";
    if (res) {
      this.genderValue = res;
      formRegistration["gender"].disable();
    } else {
      this.genderValue = this.defaultGender ? this.defaultGender :this.genderValue ;
      formRegistration["gender"].enable();
    }
  }
  /**
   *calculate DOB method
   *
   * @param {string} age
   * @param {string} month
   * @memberof RecurringAppointmentsComponent
   */
  // calculateDob(age: string, month: string) {
  //   let agecalc;
  //   let monthcalc;

  //   if (age != "0") {
  //     agecalc = age.split("Y", 1);
  //   } else {
  //     agecalc = 0;
  //   }
  //   if (month != "0") {
  //     monthcalc = month.split("M", 1);
  //   } else {
  //     monthcalc = 0;
  //   }
  //   var todayDate = new Date();
  //   var ageyear = todayDate.getFullYear() - Number(agecalc);
  //   var agemonth = todayDate.getMonth() - Number(monthcalc);
  //   var ageday = todayDate.getDate() - 0;
  //   this.appointmentForm.controls.DOB.setValue(
  //     new Date(ageyear, agemonth, ageday)
  //   );
  // }
  calculateDob(age: string, month: string) {
    let formAppointment = this.appointmentForm.controls;

    let agecalc;
    let monthcalc;

    if (age != "0") {
      agecalc = age.split("Y", 1);
    } else {
      agecalc = 0;
    }
    if (month != "0") {
      monthcalc = month.split("M", 1);
    } else {
      monthcalc = 0;
    }
    var todayDate = new Date();
    var ageyear = todayDate.getFullYear() - Number(agecalc);
    var agemonth = todayDate.getMonth() - Number(monthcalc);
    var ageday = todayDate.getDate() - 0;
    this.appointmentForm.controls["DOB"].setValue(
      new Date(ageyear, agemonth, ageday)
    );
    formAppointment["DOB"].setValue(new Date(ageyear, agemonth, ageday));

  }
  /**
   *clear form
   *
   * @memberof RecurringAppointmentsComponent
   */
  clearForm() {
    this.imageUser = null;
    this.appointmentForm.reset();
    this.patientInfoDisplay = null;
    this.resultFound = false;
    this.patientData=false;
  }
  /**
   *On save click calling method
   *
   * @param {*} form
   * @return {*}
   * @memberof RecurringAppointmentsComponent
   */
   onSubmit(form) {
    // if(this.dilogData.waitingPatient){
    //   this.ngxService.start();

    //   let Payload={
    //     id:this.dilogData.waitingPatient.id,
    //     startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
    //     endTimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
    //     slots: this.slectedSlotId
    // }
    // this.generalApiServiceapt
    // .patchTypeApi(
    //   OPD_API_URL.OPD_SERVICE,
    //   OPD_API_URL.CONFIRM_WAITING_PATIENT,
    //   Payload
    // )
    // .subscribe((response: any) => {
    //   this.ngxService.stop();
    //   if(response){
    //     this.snackBar.open("Patient Confirm Successfully","Success",{duration:2000});
    //     this.dialogRef.close();
      
    //     this.appointmentForm.reset();
    //     this.reason = "";
    //     if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
    //       localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
    //   }
    // })
    // }else{
    for (var i in this.appointmentForm.controls) {
      this.appointmentForm.controls[i].markAsTouched();
    }
    if (this.appointmentForm.valid) {
      if(this.unAvailableSlot > 0){
        this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("AppointmentPage.PleaseSelectAvailableSlot"),
        {
          duration: 3000,
        }
      );
      return;
      }
      const isReschedule =  this.autoRescheduleData ? this.autoRescheduleData.appointmentType : false
     if (isReschedule==true){
      if(!this.reason){
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.selectreason"),
        {
          duration: 3000,
        }
      );
      return;
      }
     }
      if (this.isHsc && this.checkedPackageList.length == 0) {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.warning"),
          this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
          {
            duration: 3000,
          }
        );
        return;
      } else {
        const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
          width: "20pc",
          data: { displayText: "doyouwanttoproceed" },
        });
        this.subscriptionList.add(
          dialogRef.afterClosed().subscribe((result) => {
            if (result.confirm == "yes") {
              this.saveAppointment(form);
            }
          })
        );
      }
    } else {
      this.snackBar.open(
        this.langService.get("CommonAppoinment.warning"),
        this.langService.get("CommonAppoinment.pleaseEnterallmandatory"),
        {
          duration: 3000,
        }
      );
      return;
    }
  // }
  }
  
  /**
   *save appointment method
   *
   * @param {*} form
   * @memberof RecurringAppointmentsComponent
   */
  saveAppointment(form) {
  let specialList=[];
   if(this.checkArray.length>0)
  {
   this.checkArray.forEach(element => {
    let listItem = {
      system: "EN",
      code: element.code,
      display: element.desc
  }
     specialList.push(listItem)
   });
   }
    this.saveAction = true;
    var patCat: any = {};
    var patient: any = {};
    if (this.patientTypeCat == OPD_CONST.aptpatientType.desc) {
      patCat = {
        code: OPD_CONST.aptpatientType.code,
        display: OPD_CONST.aptpatientType.desc,
        system: OPD_CONST.aptpatientType.system,
      };
      patient = {
        code: this.selectedPatient.mrn,
        display: this.selectedPatient.id,
        system: OPD_CONST.appoinmentRef.extendedPatient,
      };
    } else {
      patCat = {
        code: OPD_CONST.aptpatientTypeTemp.code,
        display: OPD_CONST.aptpatientTypeTemp.desc,
        system: OPD_CONST.aptpatientTypeTemp.system,
      };
      patient = {
        code: "",
        display: "",
        system: "",
      };
    }
    var obj = {
      code: "",
      display: "",
      system: "",
    };
    let aptTypeValue = this.dilogData.appointmentTypeList.find(
      (s) => s.code == this.dilogData.appointmentType
    );
    let conTypeValue = this.dilogData.consultationtypeList.find(
      (s) => s.code == this.dilogData.consultationtype
    );
    let deptValue = this.dilogData.departmentList.find(
      (s) => s.code == this.dilogData.department
    );
    let reasonValue = this.reasonList.find((s) => s.code == this.reason);
    var serviceCategory = {
      code: aptTypeValue.code,
      display: aptTypeValue.desc,
      system: OPD_CONST.aptpatientType.system,
    };
    var reason = {
      code: reasonValue ? reasonValue.code : "",
      display: reasonValue ? reasonValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    var consultationType = {
      code: conTypeValue ? conTypeValue.code : "",
      display: conTypeValue ? conTypeValue.desc : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let service = this.getObjByCode(
      this.dilogData.appointmentTypeList,
      this.dilogData.appointmentType
    );
    let entitydesc = this.getObjByCode(
      this.dilogData.doctorList,
      this.activeDoctor.code
    );
    let countryCode = {
      code: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.code
        : "",
      display: form.controls.countryCodemobile.value
        ? form.controls.countryCodemobile.value.desc
        : "",
      system: OPD_CONST.aptpatientType.system,
    };
    let packageList = [];
    if (this.checkedPackageList.length > 0) {
      this.checkedPackageList.forEach((element) => {
        let res = this.langService.createObjectList(element);
        packageList.push(res[0], res[1]);
      });
    }

    let slotsList = [];
    if(this.selectedRecurrenceIndex != 0){
      if (this.recurringBookings.length > 0) {
        this.recurringBookings.forEach((element) => {
          let res = {
            "startTimeEpoch": element.slotStartDateTime,
            "endTimeEpoch": element.slotEndDateTime,
            "slotId": element.slotId
          }
          slotsList.push(res);
        });
      }
    }
    else{
      let res = {
            "startTimeEpoch": this.selectedSlot.startDateTimeEpoch,
            "endTimeEpoch": this.selectedSlot.endDateTimeEpoch,
            "slotId": this.selectedSlot.id
          }
      slotsList.push(res);
    }

    let payload = {
      idTypeList: this.langService.createObjectList(form.controls.IdType.value),
      idNumber: form.value.IdNumber,
      idExpiry: form.value.idExpiry ? form.value.idExpiry.$d : "",
      titleList: this.langService.createObjectList(form.controls.Title.value),
      patientName: form.value.FullName,
      photo: {
        contentType: "image/jpeg",
        url:  this.imageUser,
      },
      genderList: this.langService.createObjectList(form.controls.Gender.value),
      caseTypeList: null,
      dob: form.value.DOB,
      email: form.value.Email,
      countryCode: countryCode,
      mobileNo: form.value.HandPhoneNumber,
      officeNo: form.value.OffciePhoneNumber,
      homeNo: form.value.HomePhoneNumber,
      patientType: patCat,
      patient: patient,
      referalEntity: null,
      companyList: null,
      subSpecialityList: null,
      // remarks: form.value.Remarks ? form.value.Remarks : null,
      specialityList: this.langService.createObjectList(deptValue),
      doctorList: this.langService.createObjectList(entitydesc),
      // startTimeEpoch: new Date(this.selectedSlots.start).getTime() / 1000,
      // endtimeEpoch: new Date(this.selectedSlots.end).getTime() / 1000,
      serviceList: this.langService.createObjectList(service),
      serviceCategory: serviceCategory,
      // slots: this.slectedSlotId,
      appointmentType: serviceCategory,
      consultationType: consultationType,
      isReal: form.value.realdob,
      extendedAddress: {
        countryList: this.langService.createObjectList(
          form.controls.countryPrimary.value
        ),
        cityList: this.langService.createObjectList(
          form.controls.cityPrimary.value
        ),
        stateList: this.langService.createObjectList(
          form.controls.statePrimary.value
        ),
        areaList: this.langService.createObjectList(
          form.controls.subDistrictPrimary.value
        ),
        postCode: form.value.pincodePrimary ? form.value.pincodePrimary : null,
        addressLine: form.value.addressPrimary
          ? form.value.addressPrimary
          : null,
      },
      specialRequirements: this.checkArray.length>0?specialList:[],
      trn: this.dilogData.reScheduleData
        ? this.dilogData.reScheduleData.type == OPD_CONST.appoinmentRef.temp
          ? this.dilogData.reScheduleData.MRN
          : ""
        : "",
      // existingAppointmentId: this.dilogData.reScheduleData
      //   ? this.dilogData.reScheduleData.id
      //   : "",
      // rescheduleRemarks: this.dilogData.reScheduleData ? this.reschRemarks : "",
      reason: reason ? reason : obj,
      packageList: packageList,
      slotDTOList: slotsList
    };
    this.generalApiServiceapt
      .postTypeApi(
        OPD_API_URL.OPD_SERVICE,
        OPD_API_URL.SAVE_RECURRING_APPOINTMENT,
        payload
      )
      .subscribe((response: any) => {
        this.saveAction = false;
    
      let isReschedue=this.dilogData.reScheduleData?this.dilogData.reScheduleData.isReschedule:false;
        let message=isReschedue?   this.langService.get("CommonAppoinment.successfullyrescheduled"):this.langService.get("CommonAppoinment.successfullycreated")
        this.snackBar.open(
          this.langService.get("CommonAppoinment.success"),

          this.langService.get(
            message
          ),
          {
            duration: 5000,
          }
        );
        this.dialogRef.close();
        // let reqPayload = {
        //   transactionId: response.appointment ? response.appointment.id : "",
        //   type: OPD_REPORT_TYPE.pdf,
        //   reportName: OPD_REPORT_NAME.appointment_Slip,
        //   isReports: false,
        // };
        // localStorage.setItem(
        //   OPD_CONST.reportPayload,
        //   JSON.stringify(reqPayload)
        // );
        // window.open(opdNavigation.REPORT_NAVIGATE);
        this.appointmentForm.reset();
        this.reason = "";
        if (localStorage.getItem(OPD_CONST.appoinmentRef.aptResData))
          localStorage.removeItem(OPD_CONST.appoinmentRef.aptResData);
      });
  }
  
  /**
   *getobj method
   *
   * @param {any[]} list
   * @param {string} code
   * @return {*}  {string}
   * @memberof RecurringAppointmentsComponent
   */
  getObjByCode(list: any[], code: string): string {
    let value;
    if (list && list.length > 0) {
      value = list.find((i) => i.code == code);
    }
    return value;
  }
  /**
   *selectd image
   *
   * @memberof RecurringAppointmentsComponent
   */
  selectFile() {
    document.getElementById(OPD_CONST.appoinmentRef.fileAttachment).click();
  }

  /**
   *select handle file
   *
   * @param {*} evt
   * @memberof RecurringAppointmentsComponent
   */
  handleFileSelect(evt) {
    var files = evt.target.files;
    var file = files[0];
    if (files && file) {
      var reader = new FileReader();
      reader.onload = this._handleReaderLoaded.bind(this);
      reader.readAsBinaryString(file);
    }
  }
  /**
   *load event for image
   *
   * @param {*} readerEvt
   * @memberof RecurringAppointmentsComponent
   */
  _handleReaderLoaded(readerEvt) {
    var binaryString = readerEvt.target.result;
    this.base64textString = btoa(binaryString);
    this.imageUser = OPD_CONST.appoinmentRef.imageData + this.base64textString;
  }

  /**
   *Destroy method
   *
   * @memberof RecurringAppointmentsComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
  }

  toTimestamp(strDate) {
    const datum = Date.parse(strDate);
    return datum / 1000;
  }
  /**
   *selection change value
   *
   * @param {*} name
   * @param {*} value
   * @memberof RecurringAppointmentsComponent
   */
  selectOnChange(name, value) {
    this.dropdownValues[name] = value.id;
  }
  /**
   *Select on click
   *
   * @param {*} control
   * @param {*} parent
   * @param {*} child
   * @memberof RecurringAppointmentsComponent
   */
  selectOnClick(control, parent, child) {
    let _this = this;
    try {
      let value = "";
      let hasParam = false;
      if (
        control.url &&
        control.url.includes("{") &&
        control.url.includes("{") &&
        !control.url.includes("{UnitMaster}")
      ) {
        let param = control.url.substring(
          control.url.lastIndexOf("{") + 1,
          control.url.lastIndexOf("}")
        );
        if (this.dropdownValues[param]) {
          control.url = control.url.replace(
            /\{.*?\}/,
            "'" + this.dropdownValues[param].trim() + "'"
          );
        } else {
          control.url = control.url.replace(/\{.*?\}/, "''");
        }
        hasParam = true;
      }
      if (
        !this.searchList[parent].controls[child].options ||
        this.searchList[parent].controls[child].options.length == 0 ||
        hasParam
      ) {
        this.baseservice.setResourceURL("/");
        this.subscriptionList.add(
          this.baseservice.getResource(control.url).subscribe((res) => {
            this.searchList[parent].controls[child].options = res;
            setTimeout(() => {
              document.getElementById(control.name).click();
            }, 500);
          })
        );
      }
    } catch (ex) {}
  }
  /**
   *Clear Search
   *
   * @memberof RecurringAppointmentsComponent
   */
  clearSearch() {
    this.searchList.forEach((search) => {
      search.controls.forEach((control) => {
        this[control.name] = "";
        control.searchValue = "";
        control.options=control.masterList;
      });
    });
  }

    dropdownOnSearch(control: SearchControl, event) {
      if (!control.masterList || control.masterList.length == 0)
        control.masterList = control.options;
      control.searchValue = event.srcElement.value;
      if (control.masterList.length > 0) {
        control.options = control.masterList.filter((i) =>
          i.desc.toString().toLowerCase().includes(control.searchValue.toLowerCase())
        );
      }
    }
  /**
   *set Search existing Patient data
   *
   * @param {*} data
   * @memberof RecurringAppointmentsComponent
   */
  setSearch(data) {

    let keysArray = Object.keys(data);
    let hasValue = false;
    
    for (let i = 0; i < keysArray.length; i++) {
      let value = data[keysArray[i]];
      if (  value !== "" && value !== null && value !== undefined 
      ) {
        hasValue = true;
        break; 
      }
    }
    
    if (hasValue) {
      const birthDate = data.dob
      ?  moment(data.dob, "DD/MM/YYYY hh:mm:ss aa").format("YYYY-MM-DD")
      : "";
      this.partientSearch = {
        MRN: data.MRN ? data.MRN : "",
      PatientName: data.PatientName ? data.PatientName : "",
      identificationType: data.identificationType
        ? data.identificationType
        : "",
      identificationNumber: data.identificationNumber
        ? data.identificationNumber
        : "",
      MobileNo: data.MobileNo ? data.MobileNo : "",
      birthDate: birthDate,
      offset: this.offset,
      limit: this.limit,
    };
    this.clearSearch();
    var payload = this.appoinmentServiceApt.getSearchPatient(this.partientSearch);
    this.subscriptionList.add(
      this.generalApiServiceapt
        .getTypeApi(OPD_API_URL.OPD_SERVICE, payload)
        .subscribe((res) => {
          this.patientList = res;
          this.patientData = true;
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          const existingData = this.dataSource?.data || [];
          const updatedData = [...res];
          this.dataSource = new MatTableDataSource<any>(updatedData);
          this.loadingData = false;
          if (this.dilogData.reScheduleData)
            this.radioClicked1(this.patientList[0]);
        })
    );
    } else {
       this.snackBar.open(
        this.langService.get("CommonAppoinment.onesearchparameter"),
        this.langService.get("CommonAppoinment.warning"),
         {
        duration: 3000,
      });
    }
  }
  /**
   *set temp patient data
   *
   * @param {*} data
   * @memberof RecurringAppointmentsComponent
   */
  setTempPatient(data) {
    var partientSearch = {
      mrn: data.MRN ? data.MRN : "",
    };
    this.clearSearch();
    this.baseservice.setResourceURL(OPD_API_URL.OPD_SERVICE);
    this.subscriptionList.add(
      this.baseservice
        .getResource(OPD_API_URL.OPD_TEMP_PATIENT_SEARCH + partientSearch.mrn)
        .subscribe((res) => {
          this.recordsLength = res.length;
          this.resultFound = true;
          this.displayedColumns = OPD_CONST.displaypatientList;
          this.dataSource = new MatTableDataSource<any>(res);
          if (this.dilogData.reScheduleData) this.resultFound = false;
          this.selectedPatient = res;
          (this.genderValue = res.genderList ? res.genderList[0].code : ""),
            (this.primaryValue = res.primaryIdentificationType
              ? res.primaryIdentificationType[0].code
              : ""),
            (this.prefixValue = res.prefixList ? res.prefixList[0].code : ""),
            (this.mobileCodeValue = res.countryCode
              ? res.countryCode.code
              : ""),
            (this.countryValue = res
              ? res.extendedAddress
                ? res.extendedAddress.countryList
                  ? res.extendedAddress.countryList[0].code
                  : null
                : null
              : null);
          let remarks = this.dilogData.reScheduleData
            ? this.dilogData.reScheduleData.remarks
            : "";
          this.appointmentForm.patchValue({
             IdType: res.primaryIdentificationType
               ? res.primaryIdentificationType[0].code
               : "",             
            IdNumber: res.idNumber ? res.idNumber : "",
            FullName: res.patientName,
            Email: res.email ? res.email : "",
            HandPhoneNumber: res.mobileNo ? res.mobileNo : "",
            OffciePhoneNumber: res.officeNo ? res.officeNo : "",
            HomePhoneNumber: res.homeNo ? res.homeNo : "",
            DOB: res.dob ? new Date(res.dob) : "",
            idExpiry: res.idExpiry ? new Date(res.idExpiry) : "",
            Remarks: remarks,
            addressPrimary: res.extendedAddress
              ? res.extendedAddress.addressLine
              : "",
            pincodePrimary: res.extendedAddress
              ? res.extendedAddress.postCode
              : "",
          });
          this.getStatePrimaryList(
            res.extendedAddress && res.extendedAddress.countryList
              ? res.extendedAddress.countryList[0].code
              : "",
            true
          );
        })
    );
  }
  /**
   *mobile format
   *
   * @memberof RecurringAppointmentsComponent
   */
  mobileNumberFormat() {
    let trimmedNumber = this.mobile.replace(/-/g, "");
    let A = trimmedNumber.substr(0, 3);
    let B = trimmedNumber.substr(3, 11);
    let str1 = trimmedNumber.length >= 4 ? "-" + B : B;
    this.mobile = A + str1;
  }
  /**
   *days in month
   *
   * @param {*} date2_UTC
   * @return {*}
   * @memberof RecurringAppointmentsComponent
   */
  DaysInMonth(date2_UTC) {
    var monthStart: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth(),
      1
    );
    var monthEnd: any = new Date(
      date2_UTC.getFullYear(),
      date2_UTC.getMonth() + 1,
      1
    );
    var monthLength = (monthEnd - monthStart) / (1000 * 60 * 60 * 24);
    return monthLength;
  }
  /**
   *load slots
   *
   * @memberof RecurringAppointmentsComponent
   */
  loadSlots() {
    const len = this.timeSlotsArray.length;
    for (let i = 0; i < len; i++) {
      const obj = {
        start: "",
        end: "",
        startValue: "",
        endValue: "",
        status: "",
        slotId: "",
      };
      if (
        this.timeSlotsArray[i + 1] &&
        this.timeSlotsArray[i].end == this.timeSlotsArray[i + 1].start
      ) {
        obj.status = this.timeSlotsArray[i].status;
        obj.start = this.timeSlotsArray[i].start;
        obj.end = this.timeSlotsArray[i].end;
        obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
        obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
        obj.slotId = this.timeSlotsArray[i].id;
      } else {
        if (i + 1 == len) {
          obj.status = this.timeSlotsArray[i].status;
          obj.start = this.timeSlotsArray[i].start;
          obj.end = this.timeSlotsArray[i].end;
          obj.startValue = this.timeSlotsArray[i].startDateTimeEpoch;
          obj.endValue = this.timeSlotsArray[i].endDateTimeEpoch;
          obj.slotId = this.timeSlotsArray[i].id;
        } else {
          if (this.breakTimes.start != undefined) {
            obj.status = "break";

            obj.start = this.breakTimes.start;
            obj.end = this.breakTimes.end;
            obj.startValue = this.breakTimes.start;
            obj.endValue = this.breakTimes.end;
            obj.slotId = "";
          }
        }
      }
      this.timeSlotList.push(obj);
    }
  }
  /**
   *radio clicked
   *
   * @param {*} i
   * @memberof RecurringAppointmentsComponent
   */
  radioClicked1(i) {
    if(i.isBlocked==false) {
      this.patientData=false;
      this.isVip=i.vip;
      this.isNoteVisible = i.patientNotes ? i.patientNotes.note :"";
    this.isDisabled = true;
    this.resultFound = false;
    this.selectedPatient = i;
    (this.genderValue = i.gender ? i.gender.code : ""),
      (this.primaryValue = i.primaryIdentifier ? i.primaryIdentifier.code : ""),
      (this.prefixValue = i.title ? i.title.code : ""),
      (this.mobileCodeValue = i.mobileNumber ? i.mobileNumber.countryCode : i.countryCode?i.countryCode:"");
    this.countryValue = i
      ? i.extendedAddress
        ? i.extendedAddress.country.code
        : null
      : null;
    let remarks = this.dilogData.reScheduleData
      ? this.dilogData.reScheduleData.remarks
      : this.dilogData?.waitingPatient?this.dilogData.waitingPatient.remarks:"";
      this.defaultGender = i.gender ? i.gender.code : ""
      if (i.title) {
        const prefix = this.prefixCodeList.find(item => item.code === i.title.code);
        if (prefix) {
          this.getGender(prefix);
        }
      }
      let mrn=i.mrn?i.mrn:i.identifier[0].value
      let name = Array.isArray(i.name) && i.name.length > 0 ? i.name[0].text || i.name[0] : i.name;
    let gender = i.gender.code.toUpperCase();
    this.appointmentForm.patchValue({
      IdNumber: i.primaryIdentifier ? i.primaryIdentifier.value : "",
      FullName: name,
      Email: i.telecom ? i.telecom[0].value : "",
      HandPhoneNumber: i.mobileNumber ? i.mobileNumber.mobileNumber :  i.telecom ? i.telecom[1].value:"",
      OffciePhoneNumber: i.telecom ? i.telecom[2].value : "",
      HomePhoneNumber: i.telecom ? i.telecom[3].value : "",
      DOB: new Date(i.birthDate),
      IdType:  i.primaryIdentifier ? i.primaryIdentifier.code : "",
      idExpiry: i.primaryIdentifier
        ? i.primaryIdentifier.period
          ? new Date(i.primaryIdentifier.period.end)
          : ""
        : "",
      Remarks: remarks,
      addressPrimary: i.extendedAddress ? i.extendedAddress.addressLine : "",
      pincodePrimary: i.extendedAddress ? i.extendedAddress.postCode : "",
    });
    this.getStatePrimaryList(
      i.extendedAddress && i.extendedAddress.country
        ? i.extendedAddress.country.code
        : "",
      true
    );
    var dobFormatted = "";
    var patientAge = "";
    if (i.birthDate) {
      dobFormatted = this.datepipe.transform(i.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      mrn +
      " / " +
      name +
      " / " +
      (gender ? gender : "UNKNOWN") +
      " / " +
      (i.birthDate ? dobFormatted : " ") +
      " (" +
      (this.patientAge ? this.patientAge.years : "") +
      ")";
    Image: i.photo ? i.photo[0].url : "";
  }else{
    this.snackBar.open(
      this.langService.get("CommonAppoinment.alreadyBlocked"),
      this.langService.get("CommonAppoinment.warning"),
      {
      duration: 3000,
    });
  }
  }
  /**
   *set mobiel format values
   *
   * @param {string} value
   * @param {string} name
   * @memberof RecurringAppointmentsComponent
   */
  mobileFormat(value: string, name: string) {
    var r = /(\D+)/g,
      npa = "",
      last4 = "";
    value = value.replace(r, "");
    npa = value.substr(0, 3);
    last4 = value.substr(3, 10);
    value = npa + "-" + last4;
    if (value.replace("-", "").trim() == "") value = "";
    if (name == OPD_CONST.aptref.mobile) {
      this.appointmentForm.controls["HandPhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.home) {
      this.appointmentForm.controls["HomePhoneNumber"].setValue(value);
    } else if (name == OPD_CONST.aptref.work) {
      this.appointmentForm.controls["OffciePhoneNumber"].setValue(value);
    }
  }
  /**
   *patient type change on event
   *
   * @param {*} $event
   * @memberof RecurringAppointmentsComponent
   */
  public patientTypeChange($event) {
    this.appointmentForm.reset();
    this.patientTypeCat = $event.value;
    this.patientType = $event.value;
    this.isPatientNew = $event.value == "new";
    this.disableForm = this.isPatientNew;
  }
  /**
   *clsose mehthod
   *
   * @memberof RecurringAppointmentsComponent
   */
  closeModal() {
    this.dialogRef.close();
  }

  /**
   * On patient select
   * @param patient patient DTO
   *
   * @memberof PatientRegistrationComponent
   */
  patientOnSelect(patient: PatientDTOObject) {
    this.patient = patient;
    this.patientId = patient.id;
    this.mrn = patient.mrn;
    var dobFormatted = "";
    var patientAge = "";
    if (patient.birthDate) {
      dobFormatted = this.datepipe.transform(patient.birthDate, "dd/MM/yyyy");
    }
    this.patientInfoDisplay =
      patient.mrn +
      " / " +
      patient.fullName +
      " / " +
      (patient.gender ? patient.gender : "Unknown") +
      " / " +
      (patient.birthDate ? dobFormatted + " " + patientAge : "");
    this.patientImage = patient.photo ? patient.photo.url : "";

    this.radioClicked1(this.data);
  }
  setPatternToMobileNumber(event){
    if (event.regex) {
      const regexPattern = event.regex.replace(/^\/|\/$/g, '');
      this.appointmentForm.controls["HomePhoneNumber"].setValidators([
        Validators.pattern(new RegExp(regexPattern))
      ]);
      const matches = event.regex.toString().match(/\{(\d+),(\d+)\}/);
      if (matches && matches.length > 1) {
        this.mobileNoMax = Number(matches[2]);
        this.mobileNoMin = Number(matches[1]);
      } 
    } else {
      this.appointmentForm.controls["HomePhoneNumber"].markAsTouched();
    }
    this.appointmentForm.controls["HomePhoneNumber"].updateValueAndValidity();
  }
  onTableScroll(e) {
    const tableViewHeight = e.target.offsetHeight; // viewport
    const tableScrollHeight = e.target.scrollHeight; // length of all table
    const scrollLocation = e.target.scrollTop; // how far user scrolled
    const buffer = 500;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    if (scrollLocation > limit && !this.loadingData) {
      this.loadingData = true; 
      this.offset += 1;
      this.setSearch(this.partientSearch);
    }
  }
  getWaitingpatient(){
    const form = this.appointmentForm.controls;
    const patientData = this.dilogData.waitingPatient?.patient || this.dilogData.waitingPatient?.temporaryPatient || null;

    if(this.dilogData.waitingPatient.specificDateList){
      this.datePreferanceDiaplay = this.convertTimestampsToDates(this.dilogData.waitingPatient.specificDateList);
    }
    if(this.dilogData.waitingPatient.expectedEndDateTime && this.dilogData.waitingPatient.expectedStartDateTime){
      this.datePreferanceDiaplay =`${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedStartDateTime  * 1000), 'dd/MM/yyyy') } To
      ${this.datepipe.transform(new Date(this.dilogData.waitingPatient.expectedEndDateTime  * 1000), 'dd/MM/yyyy') }`
    }
     
  this.selectedPatient = patientData;
    if (this.dilogData.waitingPatient?.patientType?.code === 'TEMP') {
      const primaryIdType = patientData.primaryIdentificationType?.[0];
      this.primaryValue = primaryIdType?.code || "";
      this.primaryIdentificationOnChange(primaryIdType);
      
      this.prefixValue = patientData.title?.code || '';
      this.genderValue = patientData.gender?.code || '';
      this.mobileCodeValue = patientData.countryCode?.code || '';
      
      const country = patientData.extendedAddress?.country;
      this.countryValue = country?.code || '';
      if (country?.code) {
        this.getStatePrimaryList(country.code, true);
      }
      
      this.stateValue = patientData.extendedAddress?.state?.code || '';
      
      form["IdNumber"].patchValue(patientData.idNumber || "");
      form["FullName"].patchValue(patientData.patientName || "");
      form["Email"].patchValue(patientData.email || "");
      form["HandPhoneNumber"].patchValue(patientData.mobileNumber || "");
      form["OffciePhoneNumber"].patchValue(patientData.officeNo || "");
      form["HomePhoneNumber"].patchValue(patientData.homeNo || "");
      form["DOB"].patchValue(patientData.birthDate ? new Date(patientData.birthDate) : null);
      form["idExpiry"].patchValue(patientData.idExpiry ? new Date(patientData.idExpiry) : null);
      form["Remarks"].patchValue(this.dilogData.waitingPatient?.remarks || "");
      form["addressPrimary"].patchValue(patientData.extendedAddress?.addressLine || "");
      form["pincodePrimary"].patchValue(patientData.extendedAddress?.postCode || "");
      form["realdob"].patchValue(this.dilogData.waitingPatient?.isReal || false);
    }else{
      this.patientType="registered";
      this.radioClicked1(this.selectedPatient);
    }
    this.appointmentForm.disable();
  }
  convertTimestampsToDates(timestamps: number[]): string {
    return timestamps
      .map(timestamp => this.datepipe.transform(new Date(timestamp * 1000), 'dd/MM/yyyy'))
      .join(', ');
  }
  emailOrMaskedValidator(): ValidatorFn {
    const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
    const maskedPattern = /^[a-zA-Z]\*+[a-zA-Z]$/;
  
    return (control: AbstractControl) => {
      const value = control.value;
      if (!value) return null;
  
      const isEmail = emailPattern.test(value);
      const isMasked = maskedPattern.test(value);
  
      return isEmail || isMasked ? null : { invalidEmailOrMask: true };
    };
  }

  getRecurringAppointments(){
    let payload = {
      "doctorCode": this.doctor.code,
      "departmentCode": this.data.department,
      "selectedWeekDays":(this.selectedRecurrenceIndex == 2) ? this.selectedDays :[],
      "recurringType": (this.selectedRecurrenceIndex == 1) ? 'Daily' : (this.selectedRecurrenceIndex == 2) ? 'Weekly': (this.selectedRecurrenceIndex == 3) ? 'Monthly' : "",
      "recurringInterval": (this.selectedRecurrenceIndex == 1) ? this.dailyrepeatEvery : (this.selectedRecurrenceIndex == 2) ? this.weeklyrepeatEvery: (this.selectedRecurrenceIndex == 3) ? this.monthlyRepeatEvery : "",
      "recurrenceOccurrence": (this.selectedRecurrenceIndex == 1) ? this.dailyOccurrence : (this.selectedRecurrenceIndex == 2) ? this.weeklyOccurrence: (this.selectedRecurrenceIndex == 3) ? this.monthlyOccurrence : "",
      "startEpochDateTime": this.selectedSlot.startDateTimeEpoch,
      "endEpochDateTime": this.selectedSlot.endDateTimeEpoch,
      "selectedMonthDays": (this.selectedRecurrenceIndex == 3) ? [this.dayOfMonth] : []
  }
  this.generalApiServiceapt
  .postTypeApi(
    OPD_API_URL.OPD_SERVICE,
    OPD_API_URL.GET_RECURRING_APPOINTMENT_SLOTS,
    payload
  )
  .subscribe((response: any) => {
    if(response && response.payload){
      this.recurringBookings = response.payload;
      this.unAvailableSlot = this.recurringBookings.filter(slot => slot.slotStatus !== 'Available').length;
      this.isShowRecurringSlots = true;
      this.showRecurringPanel = false;
    }
  });
  }

  selectSlot(index: number) {
    this.selectedSlotIndex = this.selectedSlotIndex === index ? null : index;
  }

  deleteSlot(index: number) {
    this.recurringBookings.splice(index, 1);
    this.selectedSlotIndex = null;
    this.unAvailableSlot = this.recurringBookings.filter(slot => slot.slotStatus !== 'Available').length;
  }

  changeTime(index: number, booking){
    this.viewMode = 'week';
    this.showRecurringPanel = false;
    this.isShowBookingCalendar= true;
    this.isShowRecurringSlots = false;
    if(booking.slotStatus == "UnAvailable"){
      this.currentDate = new Date(booking.slotStartDateTime);
    }else{
      this.currentDate = new Date(booking.date);
    }
    this.generateView(); 
     if(booking.slotStatus == "UnAvailable"){
       this.onDateClick(new Date(booking.slotStartDateTime), booking);
    }else{
      this.onDateClick(new Date(booking.date), booking);
    }
  }

  goToSelectAppointment(){
    this.selectedSlotIndex = null;
    this.recurringBookings = [];
    this.isShowRecurringSlots = false;
    this.isShowBookingCalendar = true;
  }

  goToPatientForm(){
     this.isShowRecurringSlots = false;
     this.isShowBookingCalendar = false;
  }
}
